/* eslint-disable */
import gql from 'graphql-tag';

export const GET_USERFLOWS = gql`
  query {
    userFlow {
      getUserFlows(projectId: "${process.env.REACT_APP_PROJECT_ID}", filterWithConditions: true) {
        id
        description
        title
        userFlowSteps {
          contentGroup {
            contentPages(status: [PUBLISHED, UNPUBLISHED], topLevelOnly: true) {
              ...contentPageFields
              contentPageChildren(status: [PUBLISHED, UNPUBLISHED]) {
                ...contentPageFields
                contentPageChildren(status: [PUBLISHED, UNPUBLISHED]) {
                  ...contentPageFields
                  contentPageChildren(status: [PUBLISHED, UNPUBLISHED]) {
                    ...contentPageFields
                  }
                }
              }
            }
            description
            estimatedTime
            iconAsset {
              contentType
              presignedUrl
              s3Key
            }
            description
            id
            releaseDate
            sort
            status
            title
            type
            url
          }
          stepName
          id
          isComplete
          lastViewedContentPage {
            id
            url
          }
          repetitionAllowed
          url
          userRepetition {
            id
            completed
            started
          }
          userStatus
        }
      }
    }
  }
  fragment contentPageFields on ContentPageType {
    id
    sort
    title
    url
    hasBeenViewed
  }
`;
